import { useState } from "react";
import T from "../theme";
import { GALLERY_ITEMS } from "../data";
import Reveal from "../components/Reveal";
import { Section, SectionLabel } from "../components/Section";

const TAG_CLR = {
  ceremony: T.blue, expo: "#34d399", keynote: "#a78bfa",
  awards: "#fbbf24", workshop: "#fb923c", social: T.gray2,
};
const BG = [
  "linear-gradient(135deg,#0a1628 0%,#0d2050 100%)",
  "linear-gradient(135deg,#0a1a10 0%,#0d3020 100%)",
  "linear-gradient(135deg,#150a28 0%,#200d40 100%)",
  "linear-gradient(135deg,#1a1000 0%,#2a1a00 100%)",
  "linear-gradient(135deg,#1a0800 0%,#2a1000 100%)",
  "linear-gradient(135deg,#0a0a18 0%,#12122a 100%)",
];

export default function GallerySection() {
  const [hov, setHov] = useState(null);
  return (
    <Section id="gallery" style={{ background: T.bg1 }}>
      <div className="section-pad" style={{ maxWidth: 1100, margin: "0 auto" }}>
        <Reveal><SectionLabel text="Gallery" /></Reveal>
        <Reveal delay={0.05}>
          <h2 style={{ color: T.white, fontSize: "clamp(28px,4vw,52px)", fontWeight: 900, margin: "0 0 12px", letterSpacing: -1 }}>
            Moments in Time
          </h2>
        </Reveal>
        <Reveal delay={0.08}>
          <p style={{ color: T.gray2, fontSize: 14, marginBottom: 40 }}>Highlights from past SCI-COM summits.</p>
        </Reveal>

        <div className="grid-gallery">
          {GALLERY_ITEMS.map((g, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <div
                onMouseEnter={() => setHov(i)} onMouseLeave={() => setHov(null)}
                className={g.span === 2 ? "gallery-span2" : ""}
                style={{
                  background: BG[i % BG.length],
                  border: `1px solid ${hov === i ? TAG_CLR[g.tag] : T.borderDim}`,
                  borderRadius: 8, position: "relative", overflow: "hidden",
                  gridColumn: g.span === 2 ? "span 2" : "span 1",
                  cursor: "pointer", transition: "border-color 0.25s",
                  display: "flex", alignItems: "flex-end", padding: 16,
                  height: "100%",
                }}
              >
                {/* Grid pattern */}
                <svg style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity: 0.06 }}>
                  <defs>
                    <pattern id={`g${i}`} width="24" height="24" patternUnits="userSpaceOnUse">
                      <path d="M 24 0 L 0 0 0 24" fill="none" stroke="white" strokeWidth="0.5" />
                    </pattern>
                  </defs>
                  <rect width="100%" height="100%" fill={`url(#g${i})`} />
                </svg>

                {/* Centre icon */}
                <div style={{
                  position: "absolute", inset: 0, display: "flex",
                  alignItems: "center", justifyContent: "center",
                  opacity: hov === i ? 0.3 : 0.12, transition: "opacity 0.25s",
                }}>
                  <div style={{
                    width: 64, height: 64, borderRadius: "50%",
                    border: `2px solid ${TAG_CLR[g.tag]}`,
                    display: "flex", alignItems: "center", justifyContent: "center",
                  }}>
                    <div style={{ width: 24, height: 24, borderRadius: "50%", background: TAG_CLR[g.tag], opacity: 0.6 }} />
                  </div>
                </div>

                {/* Label */}
                <div style={{ position: "relative", zIndex: 1, display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                  <div style={{
                    background: `${TAG_CLR[g.tag]}22`, border: `1px solid ${TAG_CLR[g.tag]}55`,
                    borderRadius: 3, padding: "3px 8px", fontFamily: T.mono, fontSize: 9,
                    color: TAG_CLR[g.tag], letterSpacing: 1, textTransform: "uppercase",
                  }}>{g.tag}</div>
                  <span style={{ color: T.gray1, fontSize: 12, fontWeight: 600 }}>{g.label}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </Section>
  );
}
